import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'
import Image from 'next/image'
import { css } from 'twin.macro';
import {useDropzone} from 'react-dropzone'
import {getLayout} from '../../../components/OrderLayout'
import {lookupStorageKey} from '../../../apollo/cache'
import {useSessionStorageState} from '../../../utils/useSessionStorageState'
import H2 from '../../../components/headings/H2'
import {OrderItem} from '../../../components/OrderItem'
import {
  CheckIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  CloudUploadIcon,
  UploadIcon,
  XIcon,
} from '@heroicons/react/outline'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
  faList,
  faRightLeft,
  faXmark,
  faCircleInfo
} from '@fortawesome/free-solid-svg-icons'
import {actions} from '../../../components/OrderActions'
import UnavailableAction from '../../../components/UnavailableAction'
import ShadowBox from '../../../components/layout/ShadowBox'
import tw from 'twin.macro'
import useBoolean from '../../../hooks/useBoolean'
import ScentAction from '../../../components/ScentAction'
import useOrderItem from '../../../hooks/useOrderItem'
import CropAction from '../../../components/CropAction'
import {gql, useMutation} from '@apollo/client'
import Button from '../../../components/Button'
import {Loading} from '../../../components/Loading'
import Subtitle from '../../../components/headings/Subtitle'
import {ORDER_FIELDS} from '../../../apollo/fragments'
import router from 'next/router'
import axios from 'axios'
import {Modal} from 'reactstrap'
import ItemListIcon from '../../../public/item-list.png'
import CloseIcon from '../../../public/close-icon.png'
import useOrderRefresher from '../../../hooks/useOrderRefresher'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import GenericSidebar from '../../../components/GenericSidebar';
import {OrderQuery, UPLOAD_FILE_TO_S3} from '../../../apollo/queries'
import {useLazyQuery} from '@apollo/client'
import { uploadToS3WithPresignedUrl } from '../../../utils/s3Upload'


const UPDATE_ORDER_ITEMS = gql`
  ${ORDER_FIELDS}
  mutation UpdateOrderItems(
    $orderId: String!
    $items: [UpdateItem!]!
  ) {
    updateOrderItems(orderId: $orderId, items: $items) {
      status
      message
      execution_time
      order {
        ...OrderFields
      }
    }
  }
`

const validReasons = ['Design']

const UpdateItems = ({state, setStorageState, referenceSection="update_items"}) => {
  const [states, setstates] = useState(state)
  const [first, setFirst] = useState(null)
  const {completed, networkStatus} = useOrderRefresher()
  const [checkSet, setCheckSet] = useState()
  const [orderMeta, setOrderMeta] = useState(null)
  useEffect(() => {
    setOrderMeta(state.order.order_metadata)
    return () => {}
  }, [completed, networkStatus, state?.order?.order_metadata])
  const [replacementError, setReplacementError] = useState(null)

  const [status, setStatus] = useState('idle') // idle, pending, resolved, rejected
  const [itemsToUpdate, setItemsToUpdate] = useState([])
  const [buttonDisabled, setButtonDisabled] = useState(true)
  const [trueState, setTureState] = useState()
  const [mutate] = useMutation(UPDATE_ORDER_ITEMS, {
    onCompleted: data => {
      if (data.updateOrderItems.status === 'success') {
        setStatus('resolved')
        setItemsToUpdate([])
        data.updateOrderItems.order &&
          setStorageState({
            ...state,
            order: data.updateOrderItems.order,
            timestamp: Date.now(),
          })
        data.updateOrderItems.order &&
          setstates({
            ...state,
            order: data.updateOrderItems.order,
            timestamp: Date.now(),
          })
        // router.push(
        //   `/order/${state.orderNumber}/success?source=updated_items`,
        // )
      } else {
        setStatus('rejected')
      }
    },
  })

  useEffect(() => {
    setstates(state)
  }, [state])

  useEffect(() => {
    checkIsFormValid()
  }, [first, itemsToUpdate])

  const checkHasEdit = useCallback((itemId, details) => {
    setItemsToUpdate(prev => {
      // 1. Is the item already added in the array?
      const isItemInItems = prev.find(
        item => +item.id === +itemId,
      )
      if (isItemInItems) {
        return prev.map(item => +item.id === +itemId ? {...item, ...details} : item)
      }
      // return prev
      return [...prev, {id: +itemId, ...details}]
    })
  }, [])

  const {order} = state
  if (!state.order) return null
  const {order_items, folder_id} = order

  function checkIsFormValid() {
    if (!first) {
      setButtonDisabled(false)
      setReplacementError('Please select a scent.')
    } else setButtonDisabled(true)

    if (status === 'pending') setButtonDisabled(true)
    else setButtonDisabled(false)

    if (!itemsToUpdate.length) setButtonDisabled(true)
    else setButtonDisabled(false)

    if (itemsToUpdate.length > 0) {
      itemsToUpdate.forEach(item => {
        // console.log('Item: ', item)
        if (item?.crop?.startsWith('Other')) {
          if (item.customCrop == '') setButtonDisabled(true)
          else setButtonDisabled(false)
        }
      })
    }
  }

  const flaggedReason = order.order_metadata.find(
    v => v.key === 'Flagged Reason',
  )?.value

  const currentAction = actions.find(
    action => action.id === 'update-items',
  )

  if (
    !currentAction ||
    (!currentAction.folders.includes(folder_id) &&
      !currentAction.flaggedFolders.includes(folder_id) &&
      flaggedReason !== 'Design')
  ) {
    return <UnavailableAction />
  }

  // Filter to only show "Custom Air Freshener" items
  const filteredItems = order_items.filter(item => {
    return item.name?.includes('Custom Air Freshener') || false;
  });

  return (
    <>
      <div className="item-box px-0">
        <div tw="w-full">
          {filteredItems.map(item => {
            return (
              <>
                <div className="">
                  <UpdateItem
                    setCheckSet={setCheckSet}
                    states={states}
                    mutate={mutate}
                    itemsToUpdate={itemsToUpdate}
                    key={item.id}
                    item={item}
                    updater={checkHasEdit}
                    orderId={order.id}
                    order={order}
                    replacementError={replacementError}
                    setFirst={setFirst}
                    remover={undefined}
                    refundState={undefined}
                    setTureState={setTureState}
                    trueState={undefined}
                    referenceSection={referenceSection}
                  />
                </div>
              </>
            )
          })}
        </div>
      </div>
    </>
  )
}

UpdateItems.getLayout = getLayout

export default UpdateItems
UpdateItems.displayName = 'UpdateItems'

export const UpdateItem = ({
  trueState,
  setTureState,
  refundState,
  setCheckSet,
  states,
  mutate,
  itemsToUpdate,
  replacementError,
  setFirst,
  item,
  updater,
  orderId,
  order,
  remover,
  type = 'New',
  quantity = null,
  showQuantity = false,
  updateOrderItem = null,
  referenceSection = "",
  isFirst = false,
}) => {
  const isReplacementLineItem = type === 'Replacement'
  const isEditItemsLineItem =
    referenceSection === 'update_items' && !showQuantity && !isReplacementLineItem
  const [_state, _setState] =useSessionStorageState(lookupStorageKey)
  const {order_items, folder_id} = order
  const [isToggled, toggle] = useBoolean(false)
  const {image, scent, crop, flag} = useOrderItem(item)
  const [saveStatus, setSaveStatus] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const [orderItems, setOrderItems] = useState()
  const [state, setState] = useState({
    crop,
    customCrop: '',
    scent,
    image,
    quantity,
    clearFlag: false,
  })
  const [draftReplacementScent, setDraftReplacementScent] = useState(state.scent)
  const [draftReplacementCrop, setDraftReplacementCrop] = useState(state.crop)
  const [modalClose, setmodalClose] = useState(false)  
  const [draftReplacementQuantity, setDraftReplacementQuantity] = useState(
    state.quantity,
  )
  const [initialQuantity, setInitialQuantity] = useState(item.quantity);
  const [isReplacementSaveEnabled, setIsReplacementSaveEnabled] = useState(false);
  const didMountRef = useRef(false)
  const [editItemsSidebarOpen, setEditItemsSidebarOpen] = useState(false); // Sidebar
  const [replacementSaveButtonClass, setReplacementSaveButtonClass] = useState("btn brand-btn popup-btn disabled-btn");
  const [savedReplacementLineItemState, setSavedReplacementLineItemState] = useState(null);
  const [savedEditItemsLineItemState, setSavedEditItemsLineItemState] = useState(null);
  const [isEditItemsSaveEnabled, setIsEditItemsSaveEnabled] = useState(false);

  const [originalOrder, setOriginalOrder] = useState(null);
  const [isOrderFetched, setIsOrderFetched] = useState(false);
  
  const [fetchOrder, { loading, data }] = useLazyQuery(OrderQuery, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data?.getOrder) {
        console.log(data?.getOrder)
        setOriginalOrder(data.getOrder);
      }
      setIsOrderFetched(true); // Mark as fetched to prevent re-fetching
    },
    onError: (error) => {
      console.error("Error fetching order:", error);
      setIsOrderFetched(true); // Prevent infinite loop even if error occurs
    },
  });
  
  useEffect(() => {
    if (type === "Replacement" && !originalOrder && !isOrderFetched) {
      if (_state?.order && _state?.email) { // ✅ Fixed syntax error
        fetchOrder({
          variables: { id: _state.order.source_id, email: _state.email },
        });
      }
    } else if (!originalOrder && !isOrderFetched) {
      setOriginalOrder(_state?.order || {}); // ✅ Prevent undefined order
      setIsOrderFetched(true);
    }
  }, [type, _state?.order?.source_id, _state?.email]); // ✅ Ensures proper dependency tracking  
  
  // Ensure `originalItem` has fallback
  const originalItem =
    type === "Replacement" && originalOrder
      ? originalOrder.order_items?.find((i) => i.id === item.id) ?? item
      : item;
  
  // console.log(originalItem);

  useEffect(() => {
    if (!didMountRef.current) didMountRef.current = true
    else {
      state.quantity === 0 && remover
        ? remover(item.id)
        : updater(item.id, state)
    }
    return () => {}
  }, [state])

  useEffect(() => {
    if (!isToggled) return
    if (updater && !state.quantity)
      setState({...state, quantity: 0})
    if (item.variation_list.length > 0) {
      item.variation_list.forEach(item => {
        if (item.key == 'customCrop') {
          setState({...state, customCrop: item.value})
        }
      })
    }
  }, [isToggled])

  useEffect(() => {
    if(state.crop != 'Just The Head(s)' && state.crop != 'Entire Body(s)' && state.crop != 'Do Not Crop' && state.crop != 'Just The Car') {
      const other_crop = item?.metadata?.find(
        v => v.key === 'Crop'
      )?.value

      setState({
        ...state,
        customCrop: other_crop
      })
    }
  }, [])

  const handlePhotoChange = (url) => {
    setState({
      ...state,
      image: url,
      clearFlag: true,
    })

    // if(updateOrderItem != null) {
    //   updateOrderItem(item, 'image', url)
    // }
  }

  const handleCropChange = (crop) =>{
    if (!showQuantity) {
      setState({...state, crop})
    }

    if (isReplacementLineItem) {
      setDraftReplacementCrop(crop)
    }

    // if(updateOrderItem != null) {
    //   updateOrderItem(item, 'Crop', crop)
    //   updateOrderItem(item, 'customCrop', '')
    // }
  }

  const handleScentChange = (scent)=> {
    if (!showQuantity) {
      setState({...state, scent})
    }

    if (isReplacementLineItem) {
      setDraftReplacementScent(scent)
    }

    // if(updateOrderItem != null) {
    //   updateOrderItem(item, 'Scent', scent)
    // }
  }

  const currentSidebarScent = isReplacementLineItem
    ? draftReplacementScent
    : state.scent
  const currentSidebarCrop = isReplacementLineItem
    ? draftReplacementCrop
    : state.crop

  useEffect(() => {
    if (modalClose) {
      setDraftReplacementScent(scent)
      setDraftReplacementCrop(crop)
    }
  }, [modalOpen])

  const handleQuantityChange = (event)=> {
    const newQuantity = Number(event.target.value); // Convert to integer
    if (isReplacementLineItem) {
      setDraftReplacementQuantity(event.target.value)
    }
  }

  useEffect(() => {
    if (
      !isReplacementLineItem ||
      !editItemsSidebarOpen ||
      !showQuantity ||
      !savedReplacementLineItemState
    ) {
      return
    }

    const currentQuantity = Number(draftReplacementQuantity ?? 0)
    const isValidQuantitySelection =
      Number.isInteger(currentQuantity) &&
      currentQuantity >= 0 &&
      currentQuantity <= item.quantity

    const hasReplacementLineItemChanges =
      currentQuantity !== savedReplacementLineItemState.quantity ||
      (draftReplacementScent ?? '') !== savedReplacementLineItemState.scent ||
      (draftReplacementCrop ?? '') !== savedReplacementLineItemState.crop ||
      (state.image ?? '') !== savedReplacementLineItemState.image ||
      (state.customCrop ?? '') !== savedReplacementLineItemState.customCrop

    if (isValidQuantitySelection && hasReplacementLineItemChanges) {
      setIsReplacementSaveEnabled(true)
      setReplacementSaveButtonClass("btn brand-btn popup-btn")
    } else {
      setIsReplacementSaveEnabled(false)
      setReplacementSaveButtonClass("btn brand-btn popup-btn disabled-btn")
    }
  }, [
    isReplacementLineItem,
    editItemsSidebarOpen,
    showQuantity,
    savedReplacementLineItemState,
    draftReplacementQuantity,
    draftReplacementScent,
    draftReplacementCrop,
    state.image,
    state.customCrop,
    item.quantity,
  ])

  useEffect(() => {
    if (
      !isEditItemsLineItem ||
      !editItemsSidebarOpen ||
      !savedEditItemsLineItemState
    ) {
      return
    }

    const hasEditItemsLineItemChanges =
      (state.scent ?? '') !== savedEditItemsLineItemState.scent ||
      (state.crop ?? '') !== savedEditItemsLineItemState.crop ||
      (state.image ?? '') !== savedEditItemsLineItemState.image ||
      (state.customCrop ?? '') !== savedEditItemsLineItemState.customCrop

    setIsEditItemsSaveEnabled(hasEditItemsLineItemChanges)
  }, [
    isEditItemsLineItem,
    editItemsSidebarOpen,
    savedEditItemsLineItemState,
    state.scent,
    state.crop,
    state.image,
    state.customCrop,
  ])

  const handleCloseSidebar = () => {
    if (isReplacementLineItem && savedReplacementLineItemState) {
      setDraftReplacementQuantity(savedReplacementLineItemState.quantity)
      setDraftReplacementScent(savedReplacementLineItemState.scent)
      setDraftReplacementCrop(savedReplacementLineItemState.crop)
      setState(prevState => ({
        ...prevState,
        quantity: savedReplacementLineItemState.quantity,
        scent: savedReplacementLineItemState.scent,
        crop: savedReplacementLineItemState.crop,
        image: savedReplacementLineItemState.image,
        customCrop: savedReplacementLineItemState.customCrop,
      }))
      setIsReplacementSaveEnabled(false)
      setReplacementSaveButtonClass("btn brand-btn popup-btn disabled-btn")
      setSavedReplacementLineItemState(null)
    }

    if (isEditItemsLineItem && savedEditItemsLineItemState) {
      setState(prevState => ({
        ...prevState,
        scent: savedEditItemsLineItemState.scent,
        crop: savedEditItemsLineItemState.crop,
        image: savedEditItemsLineItemState.image,
        customCrop: savedEditItemsLineItemState.customCrop,
      }))
      setIsEditItemsSaveEnabled(false)
      setSavedEditItemsLineItemState(null)
    }

    setEditItemsSidebarOpen(false)
  }

  const FlagofItem = item?.variation_list?.find(
    v => v.key === 'Flag',
  )?.value

  return (
    <div
      style={type === 'Replacement' ? { } : {}}
      className={`
      ${!showQuantity && 'item-outer border-gray'}
      ${showQuantity && 'item-outer border-gray'}
      ${!showQuantity && FlagofItem && 'item-outer border-red'}
      ${
        state.quantity > 0 &&
        showQuantity &&
        saveStatus &&
        'item-outer border-blue'
      }
      ${
        state.quantity === 0 &&
        showQuantity &&
        'item-outer border-gray'
      }
      ${referenceSection === 'refund_section' && isFirst ? 'refund-first-item' : ''}
                      `}
      key={item.id}
      tw="mx-0 px-0"
    >
      <div
        className={`edit-items-box edit-items-box-inner`}
        key={item.id}
        css={[
          tw`!px-3 !py-3 md:!px-5 md:!py-5 flex flex-wrap relative justify-between`,
          (referenceSection === "update_items" || referenceSection === "refund_section") && tw`md:justify-between`,
          isToggled && tw``,
        ]}
      >
      {(
        (refundState?.solution === 'free-replacement') ||
        (FlagofItem && !showQuantity) ||
        (!saveStatus && showQuantity && state.quantity > 0) ||
        (showQuantity && state.quantity > 0 && saveStatus) ||
        (showQuantity && state.quantity === 0)
      ) && (
        <div
          className={`${
            refundState?.solution === 'free-replacement' &&
            'banner-text banner-text-cm colorGray'
          }
        ${FlagofItem && !showQuantity && 'banner-text banner-text-cm'}
        ${
          !saveStatus &&
          showQuantity &&
          state.quantity > 0 &&
          'banner-text banner-text-cm colorGray'
        }
        ${
          showQuantity &&
          state.quantity > 0 &&
          saveStatus &&
          'banner-text banner-text-cm colorBlue'
        }
        ${
          showQuantity &&
          state.quantity === 0 &&
          'banner-text banner-text-cm colorGray '
        }
        `}
        >
          {FlagofItem && !showQuantity
            ? FlagofItem
            : !saveStatus && showQuantity && state.quantity > 0
            ? `${0} of ${item.quantity} selected`
            : showQuantity && state.quantity > 0
            ? `${state.quantity} of ${item.quantity} selected`
            : showQuantity && state.quantity === 0
            ? `${state.quantity} of ${item.quantity} selected`
            : ''}
        </div>
      )}

        <OrderItem
          states={states}
          // order_items={order_items}
          item={originalItem}
          hasPrice={false}
          clickHandler={toggle}
          setOrderItems={setOrderItems}
          shQuantity={undefined}
          referenceSection={type === 'Replacement' ? 'refund_section' : referenceSection}
        >
          <span onClick={toggle} className="w-sm-100">
            <div className="edit-btn edit-btn-sm" tw="mb-0">
              <button
                className="btn brand-btn edit-btn review-submit-btn w-sm-100" tw="mb-0" style={{minWidth: "151px"}}
                onClick={() => {
                  setEditItemsSidebarOpen(true); // Open the sidebar
                  // setModalOpen(!modalOpen)
                  // setSaveStatus(false)
                  if (isReplacementLineItem) {
                    setDraftReplacementQuantity(state.quantity)
                    setDraftReplacementScent(state.scent)
                    setDraftReplacementCrop(state.crop)
                    setSavedReplacementLineItemState({
                      quantity: Number(state.quantity ?? 0),
                      scent: state.scent ?? '',
                      crop: state.crop ?? '',
                      image: state.image ?? '',
                      customCrop: state.customCrop ?? '',
                    })
                    setIsReplacementSaveEnabled(false);
                    setReplacementSaveButtonClass("btn brand-btn popup-btn disabled-btn");
                  }
                  if (isEditItemsLineItem) {
                    setSavedEditItemsLineItemState({
                      scent: state.scent ?? '',
                      crop: state.crop ?? '',
                      image: state.image ?? '',
                      customCrop: state.customCrop ?? '',
                    })
                    setIsEditItemsSaveEnabled(false)
                  }
                }}
              >
                {(refundState?.solution === 'free-replacement' &&
                  saveStatus &&
                  state.quantity > 0) ||
                (showQuantity &&
                  saveStatus &&
                  state.quantity > 0)
                  ? 'Edit'
                  : showQuantity
                  ? 'Select'
                  : 'Edit'}
              </button>
            </div>
          </span>
        </OrderItem>

        {/* <Modal
          toggle={() => setModalOpen(!modalOpen)}
          isOpen={modalOpen}
          className="popup-dialog edit-item-popup"
          backdrop="static"
        >
          {' '}
          <div className="p-2">
            <div className="top-header-item">
              <div className="d-flex align-items-center">
                <span className="d-flex mr-4 cart-icon">
                  {!showQuantity ? (
                    <FontAwesomeIcon icon={faList} />
                  ) : (
                    <FontAwesomeIcon icon={faRightLeft} />
                  )}
                </span>
                <span className="heading">
                  {!showQuantity ? 'Edit Items' : 'Replacement'}
                </span>
              </div>
              <span
                aria-hidden={true}
                onClick={() => {
                  setModalOpen(!modalOpen)
                  setmodalClose(true)
                  // setState({
                  //   ...state,
                  //   quantity: 0,
                  //   scent: scent,
                  //   crop: crop,
                  // })
                }}
                className="cursor-pointer close-btn"
              >
                <span className="close-icon d-flex cart-icon">
                  <FontAwesomeIcon icon={faXmark} />
                </span>
              </span>
            </div>
          </div> */}
          <GenericSidebar
            title={!showQuantity ? 'Edit Items' : 'Replacement'}
            icon={
              !showQuantity ? (
                <FontAwesomeIcon icon={faList} />
              ) : (
                <FontAwesomeIcon icon={faRightLeft} />
              )
            } // Pass dynamic icon
            isOpen={editItemsSidebarOpen}
            onClose={handleCloseSidebar}
            footer={
              <button
              disabled={
                isReplacementLineItem
                  ? !isReplacementSaveEnabled
                  : isEditItemsLineItem
                  ? !isEditItemsSaveEnabled
                  : (!showQuantity && state?.crop === '' && state?.customCrop === '') ||
                    (state?.crop === '' && state?.customCrop === '')
              }
              onClick={() => {
                toastr.options = {
                  positionClass : 'toast-top-right',
                  hideDuration: 300,
                  timeOut: 3000
                }
                setEditItemsSidebarOpen(false)
                toastr.success(`Saved`)

                if (!showQuantity) {
                  mutate({
                    variables: {
                      orderId: order.id,
                      items: itemsToUpdate,
                    },
                  })
                }

                if(updateOrderItem != null) {
                  updateOrderItem(item, {
                    image: state.image,
                    crop: isReplacementLineItem ? draftReplacementCrop : state.crop,
                    scent: isReplacementLineItem ? draftReplacementScent : state.scent,
                    customCrop: state.customCrop
                  })
                }

                if (showQuantity) {
                  const quantity =
                    draftReplacementQuantity <= item.quantity
                      ? Number(draftReplacementQuantity)
                      : state.quantity
                  setState({
                    ...state,
                    quantity,
                    scent: draftReplacementScent,
                    crop: draftReplacementCrop,
                  })
                }

                setModalOpen(!modalOpen)
                setTureState(state.quantity)
                setSaveStatus(true)
                setCheckSet(true)
                if (isReplacementLineItem) {
                  setSavedReplacementLineItemState(null)
                }
                if (isEditItemsLineItem) {
                  setSavedEditItemsLineItemState(null)
                  setIsEditItemsSaveEnabled(false)
                }
              }}
              className={
                isReplacementLineItem
                  ? replacementSaveButtonClass
                  : isEditItemsLineItem && !isEditItemsSaveEnabled
                  ? "btn brand-btn popup-btn disabled-btn"
                  : "btn brand-btn popup-btn"
              }
              tw="w-full"
              style={{maxWidth: "100%"}}
            >
              Save
              </button>
            }
          >
          <div className="modal-content-box edit-item-popup">
            <div className="modal-body p-0" tw="mb-[25px] md:mb-[25px]">
              <div
                className="crop-box"
                css={[
                  tw`flex flex-col gap-y-1 w-full pb-8`,
                ]}
              >
                {showQuantity ? (
                  <div tw="mb-4">
                    <h3 tw="text-lg text-brand">
                      How many need to be replaced?
                    </h3>
                    <div className="select-box">
                      <span className="select-icon">
                        <i className="fa fa-caret-down"></i>
                      </span>
                      <select
                        onChange={handleQuantityChange}
                        required={true}
                        value={draftReplacementQuantity}
                        tw="h-full w-full p-2 border border-gray-400 bg-white text-gray-500 focus:ring-brand rounded-md"
                      >
                        <option
                          key={0}
                          value={0}
                          css={[tw`block w-full hover:bg-gray-100 rounded-md`]}
                        >0</option>
                        {Array.from(Array(item.quantity? item.quantity : 0), (e, i) => {
                          return <option
                            key={i+1}
                            value={i+1}
                          >{i+1}</option>
                        })}
                      </select>
                    </div>
                  </div>
                ) : null}
                {!flag || flag !== 'Delivery' ? (
                  <UploadItemPhoto
                    state={state}
                    orderId={orderId}
                    itemId={item.id}
                    updatePhoto={handlePhotoChange}
                    type={type}
                    defaultImage={state.image}
                  />
                ) : (
                  <span>&nbsp;</span>
                )}
                <div tw="sm:mt-0">
                  <ScentAction
                    replacementError={replacementError}
                    setFirst={setFirst}
                    currentScent={currentSidebarScent}
                    setNewScent={handleScentChange}
                    type={type}
                  />
                  <CropAction
                    currentCrop={currentSidebarCrop}
                    setNewCrop={handleCropChange}
                    type={type}
                  />
                  {currentSidebarCrop != 'Just The Head(s)' &&
                  currentSidebarCrop != 'Entire Body(s)' &&
                  currentSidebarCrop != 'Do Not Crop' &&
                  currentSidebarCrop != "Do Not Crop (we'll keep the photo as is)" &&
                  currentSidebarCrop != 'Just The Car' ? (
                    <div tw="mt-4">
                      <h3 tw="text-lg text-brand">Other</h3>
                      <input
                        type="text"
                        required={true}
                        name="customCrop"
                        className="input-styling"
                        value={state.customCrop}
                        onChange={e => {
                          setState({
                            ...state,
                            customCrop: e.currentTarget.value,
                            crop: e.currentTarget.value,
                          })
                          if (showQuantity) {
                            setDraftReplacementCrop(e.currentTarget.value)
                          }

                          // if(updateOrderItem != null) {
                          //   updateOrderItem(item, 'Crop', e.currentTarget.value)
                          //   updateOrderItem(item, 'customCrop', e.currentTarget.value)
                          // }
                        }}
                        placeholder="Please specify"
                        tw="h-full w-full p-2 bg-white focus:ring-brand"
                      />
                      {state?.customCrop == '' &&
                        currentSidebarCrop?.replace('Other', '') == '' && (
                          <span style={{color: 'red'}}>
                            Please enter some value.
                          </span>
                        )}
                    </div>
                  ) : null}
                </div>
              </div>
              {/* <div
                tw="py-3"
                css={{
                  position: 'sticky',
                  bottom: 0,
                  zIndex: 10,
                  borderTop: '1px solid #D9D9D9',
                  backgroundColor: 'white',  // 🔥 Make background white
                }}
              >
                <button
                  disabled={
                    type === "Replacement"
                      ? !isReplacementSaveEnabled
                      : (!showQuantity && state?.crop === '' && state?.customCrop === '') ||
                        (draftReplacementCrop === '' && state?.customCrop === '')
                  }
                  onClick={() => {
                    toastr.options = {
                      positionClass : 'toast-top-right',
                      hideDuration: 300,
                      timeOut: 3000
                    }
                    setEditItemsSidebarOpen(false)
                    toastr.success(`Saved`)

                    if (!showQuantity) {
                      mutate({
                        variables: {
                          orderId: order.id,
                          items: itemsToUpdate,
                        },
                      })
                    }

                    if(updateOrderItem != null) {
                      updateOrderItem(item, {
                        image: state.image,
                        crop: draftReplacementCrop,
                        scent: draftReplacementScent,
                        customCrop: state.customCrop
                      })
                    }

                    if (showQuantity) {
                      const quantity =
                        draftReplacementQuantity <= item.quantity
                          ? Number(draftReplacementQuantity)
                          : state.quantity
                      setState({
                        ...state,
                        quantity,
                        scent: draftReplacementScent,
                        crop: draftReplacementCrop,
                      })
                    }

                    setModalOpen(!modalOpen)
                    setTureState(state.quantity)
                    setSaveStatus(true)
                    setCheckSet(true)
                  }}
                  className={type === "Replacement" ? replacementSaveButtonClass : "btn brand-btn popup-btn"}
                  tw="w-full"
                  style={{maxWidth: "100%"}}
                >
                  Save
                </button>
              </div> */}
            </div>
          </div>
          </GenericSidebar>
        {/* </Modal> */}
      </div>
    </div>
  )
}

export const ADD_PHOTO = gql`
  mutation UploadPhoto(
    $file: Upload!
    $orderId: String!
    $itemId: Int!
  ) {
    uploadPhoto(
      file: $file
      orderId: $orderId
      itemId: $itemId
    ) {
      status
      message
      execution_time
      url
    }
  }
`

export const UploadItemPhoto = ({
  state,
  orderId,
  itemId,
  updatePhoto,
  type,
  defaultImage = null,
  variant = '',
  outerStyle = {},
}) => {
  const [photo, setPhoto] = useState(defaultImage)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setPhoto(defaultImage ?? null)
  }, [defaultImage])
  
  const [uploadFileToS3] = useMutation(UPLOAD_FILE_TO_S3);
  const [mutate, {loading, error, data}] = useMutation(
    ADD_PHOTO,
    {
      onCompleted: data => {
        console.log(data, error)
        console.log(data)
        if (data.uploadPhoto.status === 'success') {
          updatePhoto(data.uploadPhoto.url)
          setPhoto(data.uploadPhoto.url)
          setIsLoading(false)
        } else {
          console.log('On Complete Error: ', data)
        }
      },
      onError: error => {
        console.log('Upload Photo Error: ', error)
      },
    },
  )

  const uploadPhoto = useCallback(async (file) => {
    try {
      const result = await uploadFileToS3({
        variables: { 
          folderKey: 'item-photos', 
          fileName: `${orderId}-${itemId}-${file.name}`,
          contentType: file.type || 'application/octet-stream'
        }
      });
      
      if (result.data?.uploadFileToS3?.status === 'success') {
        const { uploadUrl, url: s3Url } = result.data.uploadFileToS3
        await uploadToS3WithPresignedUrl(file, uploadUrl);

        updatePhoto(s3Url);
        setPhoto(s3Url);
        setIsLoading(false);
      } else {
        console.log('Error uploading photo:', result.data?.uploadFileToS3?.message);
        setIsLoading(false);
      }
    } catch (error) {
      console.log('Error uploading photo:', error);
      setIsLoading(false);
    }
  }, [uploadFileToS3, orderId, itemId, updatePhoto]);

  const onDrop = useCallback(acceptedFiles => {
    acceptedFiles.forEach(file => {
      const reader = new FileReader()
      uploadPhoto(file)
      reader.onload = () => {
        setIsLoading(true)
      }
      reader.readAsDataURL(file)
    })
  }, [uploadPhoto])

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
  } = useDropzone({onDrop})

  const isMobile = window.innerWidth < 768;
  const isPhotoOfItemCutInHalf = variant === 'refundCutInHalf';
  return (
    <div
      tw="relative sm:h-full sm:min-h-md md:h-full lg:h-full"
      className="img-crop-outer"
      style={{ minWidth: 'auto', ...outerStyle }}
    >
      {type ? (
        <h3 tw="text-lg text-brand mb-2">
          {/* {type} Photo */}
          {type && type == "Replacement" ? "Replacement Photo" : "Photo"}
        </h3>
      ) : null}
      {!type && (
      <div tw="mb-4 sm:block lg:hidden md:block">
        <div className="item-cut-instructions info-box">
          <FontAwesomeIcon icon={faCircleInfo} className="icon"/>
          In order to make your replacement/return easy and eco-friendly, we don&apos;t require you
          to return/ship your item(s) back to us. Instead, we ask that you cut your item(s) in
          half and upload a quick photo showing the item(s) rendered unusable. This allows us
          to process your replacement/refund as soon as possible & minimizes the turnaround time
          of your replacement/refund.
        </div>
      </div>
      )}
      <div
        className="img-crop-box h-100 border-gray"
        {...getRootProps()}
        css={[
          tw`h-full relative border-dashed flex items-center justify-center bg-white text-sm text-brand text-center mb-3`,
          isDragActive && tw`border-brand`,
          isPhotoOfItemCutInHalf && photo && tw`!bg-[#e9e9e9]`,
          // isLoading && tw`border-brand bg-gray-100`,
        ]}
        style={
          !isPhotoOfItemCutInHalf
            ? {
                display: 'flex',
                flexDirection: 'column',
                minHeight: 'unset',
                borderWidth: '0',
                padding: '0',
                borderTopLeftRadius: '5px',
                borderTopRightRadius: '5px',
              }
            : {
                borderRadius: "5px",
              }
        }
      >
        {error}
        {isLoading && !error && (
          <svg
            tw="animate-spin mx-auto h-24 w-24 text-brand"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              tw="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              tw="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        )}
        <input {...getInputProps()} />
        {photo && (
          <img
            src={photo}
            alt="New picture"
            tw="max-w-full max-h-full object-contain"
            width="400"
            height="260"
            style={{
              borderTopLeftRadius: "5px", 
              borderTopRightRadius: "5px",
              border: isPhotoOfItemCutInHalf ? "0" : "2px solid #B3B3B3",
              borderBottom: isPhotoOfItemCutInHalf ? "0" : "0"
            }}
            // objectFit="contain"
          />
        )}
        {!photo && !isPhotoOfItemCutInHalf && (
          <div
            tw="flex items-center justify-center w-full flex-1 min-h-[170px]"
            style={{
              border: '2px solid #B3B3B3',
              borderBottom: 0,
              borderTopLeftRadius: '5px',
              borderTopRightRadius: '5px',
              backgroundColor: 'white',
            }}
          >
            <span style={{ color: '#D20000' }}>
              No Photo
            </span>
          </div>
        )}
        {!photo && isDragActive && (
          <p>Drop the files here ...</p>
        )}
        {!isLoading && (
          <>
          {!isPhotoOfItemCutInHalf ? (
            <div
              className="upload-image-input-box"
              tw="flex text-center"
              style={!photo ? { borderTop: '2px solid #B3B3B3' } : undefined}
            >
              <span className="upload-image-input-text">
                Upload New Photo
              </span>
            </div> )
            : (
            !photo && (
              <div tw="text-center">
                <CloudUploadIcon
                  css={[tw`h-12 w-12 mx-auto text-brand`]}
                />
                <p tw="mt-2" className="upload-file-box">
                  <span className="semi-bold text-size">
                    Upload Photo
                  </span>{' '}
                  <br />
                  <span className="text-gray">
                    Drag &amp; Drop or <u>Browse</u>
                  </span>
                </p>
              </div>
            ))
            }
          </>
        )}
      </div>
      {/* {photo && (
        <button type="reset" onClick={e => setPhoto(null)}>
          <XIcon tw="absolute top-2 right-2 w-5 h-5" />
        </button>
      )} */}
    </div>
  )
}
